module.exports = __webpack_public_path__ + "img/water.e29fb8e3.svg";